import React from 'react'
import { useSelector } from 'react-redux'
import { LoadingUIBlocker } from '@submittable/ui-components'
import { selectLoadingUIBlocker } from '../reducers/application/loadingUIBlocker'
import styles from './LoadingUIBlockerContainer.css'

const LoadingUIBlockerContainer = () => {
  const { message, timeIn, isShowing } = useSelector(selectLoadingUIBlocker)
  return isShowing ? (
    <div className={styles.loadAnimation} style={{ animationDuration: `${timeIn}ms` }}>
      <LoadingUIBlocker message={message} />
    </div>
  ) : null
}

export default LoadingUIBlockerContainer
